import React from 'react';
import styles from '../style/BrowseBy.module.scss';
import { useEducationOption } from 'modules/website/hooks/useEducationOption';
import { Link } from 'react-router-dom';
import BrowseByLoading from '../BrowseByLoading/BrowseByLoading';
export default function BrowseByGrade() {
	const { isLoading, isError, payload, error } = useEducationOption({
		type: 'options',
	});
	return (
		<div className={`py-2 ${styles.browseby}`}>
			<div className={`${styles.title}`}>Browse by Grade</div>
			<div className={styles.links}>
				{isLoading && <BrowseByLoading />}
				{isError && <div>{error}</div>}
				{payload &&
					Object.values(payload).map((item, index) => (
						<div className={styles.option} key={index}>
							<Link
								key={index}
								className={styles.link}
								to={`/taxonomy/term/${item.tid}`}
							>
								{item.name}
							</Link>
						</div>
					))}
			</div>
		</div>
	);
}
